import { concatMap } from 'lib/arrayUtils';
import buildAffiliateLink from 'lib/buildAffiliateLink';

function checkEcommerce({
  item, isLastItem, prevItem, nextItem, ecommerceEnabled,
}) {
  if (item
    && ecommerceEnabled
    && !isLastItem
    && item.type === 'embeddedImage'
    && prevItem
    && prevItem.type === 'markup'
    && prevItem.element === 'p'
    && prevItem.html.startsWith('<strong>')
    && prevItem.html.indexOf('<a') > -1
  ) {
    return { ...item, ecommerceEnabled, shopLink: prevItem };
  }

  if (item
    && ecommerceEnabled
    && !isLastItem
    && item.type === 'markup'
    && item.element === 'p'
    && nextItem
    && nextItem.type === 'embeddedImage'
    && item.html.startsWith('<strong>')
    && item.html.indexOf('<a') > -1
  ) {
    // Legacy Link Replacement. Nasty.
    const matches = item.html.match(/href="([^"]+)"/);
    if (matches && matches.length) {
      const [, url] = matches;
      const html = item.html.replace(/href="([^"]+)"/, `href="${buildAffiliateLink(url)}" target="_blank"`);

      return { ...item, html, ecommerceEnabled };
    }

    return { ...item, ecommerceEnabled };
  }

  return item;
}

export default function addEcommerce(ecommerceEnabled) {
  return (bodyArray) => concatMap(bodyArray, (item, i) => {
    const checkedItem = checkEcommerce({
      item,
      isLastItem: i === bodyArray.length - 1,
      prevItem: bodyArray[i - 1],
      nextItem: bodyArray[i + 1],
      ecommerceEnabled,
    });

    return [checkedItem];
  });
}
